import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { BrandMark, Fern } from "@/components/site/BrandMark";
import { Lock, Mail, Loader2, ArrowLeft } from "lucide-react";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/dashboard", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Bem-vinda, Tacilaine! 💚");
      navigate("/dashboard", { replace: true });
    } else {
      toast.error(res.error);
    }
  };

  const input =
    "w-full rounded-xl bg-white border border-[#5B6E5B]/15 pl-11 pr-4 py-3 font-body text-[#2C332A] placeholder:text-[#A8B0A2] outline-none transition-[border-color,box-shadow] duration-300 focus:border-[#C87A5E] focus:ring-2 focus:ring-[#C87A5E]/25";

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F0E6] px-5 relative overflow-hidden">
      <Fern color="#5B6E5B" opacity={0.12} className="absolute -left-10 -top-6 w-72" />
      <Fern color="#8A9A82" opacity={0.1} className="absolute -right-16 bottom-0 w-80 scale-x-[-1]" />

      <Link to="/" className="absolute top-6 left-6 inline-flex items-center gap-2 text-sm text-[#4A5D4E] hover:text-[#2C332A] transition-colors" data-testid="back-to-site">
        <ArrowLeft className="w-4 h-4" strokeWidth={1.5} /> Voltar ao site
      </Link>

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="relative w-full max-w-md rounded-3xl bg-white p-8 sm:p-10 shadow-[0_20px_60px_rgba(91,110,91,0.12)] border border-[#5B6E5B]/10"
      >
        <div className="flex flex-col items-center text-center mb-8">
          <BrandMark className="w-14 h-14 mb-3" />
          <h1 className="font-script text-4xl text-[#2C332A]">Área restrita</h1>
          <p className="font-body text-sm text-[#7A8A7A] mt-1">Acesso exclusivo da profissional</p>
        </div>

        <form onSubmit={submit} className="space-y-4" data-testid="login-form">
          <div className="relative">
            <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-[#7A8A7A]" strokeWidth={1.5} />
            <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="E-mail" className={input} required />
          </div>
          <div className="relative">
            <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-[#7A8A7A]" strokeWidth={1.5} />
            <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Senha" className={input} required />
          </div>
          <button data-testid="login-submit" type="submit" disabled={loading} className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-[#5B6E5B] px-6 py-3.5 text-[#FDFBF7] transition-[transform,background-color] duration-300 hover:bg-[#4A5D4E] hover:scale-[1.02] disabled:opacity-60">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Entrar"}
          </button>
          <div className="text-center pt-1">
            <Link to="/esqueci-senha" data-testid="forgot-password-link" className="font-body text-sm text-[#7A8A7A] hover:text-[#4A5D4E] transition-colors">
              Esqueci minha senha
            </Link>
          </div>
        </form>
      </motion.div>
    </div>
  );
}
